import { useState, useCallback } from 'react';

const THEME_STORAGE_KEY = 'iris-catalog-theme';

function getInitialDarkMode(): boolean {
  if (typeof window === 'undefined') return false;

  const stored = window.localStorage.getItem(THEME_STORAGE_KEY);
  if (stored) return stored === 'dark';

  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false;
}

export function useTheme() {
  const [isDarkMode, setIsDarkMode] = useState<boolean>(getInitialDarkMode);

  const toggleTheme = useCallback(() => {
    setIsDarkMode((prev) => {
      const next = !prev;
      window.localStorage.setItem(THEME_STORAGE_KEY, next ? 'dark' : 'light');
      return next;
    });
  }, []);

  return { isDarkMode, toggleTheme };
}
